import React from 'react';
import Button from '../common/Button';
import { Link } from 'react-router-dom';
import RubiksCube from '../RubiksCube';

const HeroAlt1 = () => {
  return (
    <section className="relative bg-cream dark:bg-black text-black dark:text-white min-h-screen flex items-center overflow-hidden transition-colors duration-300">
      <div className="container mx-auto px-4 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8 animate-fade-in">
            <div className="inline-flex items-center space-x-2 bg-black/5 dark:bg-white/10 rounded-full px-4 py-2 backdrop-blur-sm">
              <span className="w-2 h-2 bg-primary rounded-full animate-pulse" />
              <span className="text-sm font-medium uppercase tracking-wider">Amazon Growth Experts</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              <span className="block transform hover:translate-x-2 transition-transform duration-300">
                Maximize Your
              </span>
              <span className="block text-primary transform hover:translate-x-2 transition-transform duration-300 delay-100">
                Amazon Success
              </span>
            </h1>

            <p className="text-lg md:text-xl text-black/70 dark:text-white/80 max-w-2xl leading-relaxed">
              We create strategies to increase your brand's visibility on Amazon and put your products in front of the right customers. <br />
              Then, we optimize every part of your journey, from listings to PPC, to help your business succeed and grow on Amazon.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact"><Button variant="primary">GET A FREE AUDIT</Button></Link>
              <Link to="/case-studies"><Button variant="outline" className="dark:border-white dark:text-white dark:hover:bg-white dark:hover:text-black">VIEW CASE STUDIES</Button></Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-8 border-t border-black/10 dark:border-white/10">
              <div>
                <div className="text-3xl font-bold text-primary">98%</div>
                <div className="text-sm text-black/60 dark:text-white/60">Success Rate</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">5+</div>
                <div className="text-sm text-black/60 dark:text-white/60">Year Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">$75M+</div>
                <div className="text-sm text-black/60 dark:text-white/60">Revenue Generated</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">3X</div>
                <div className="text-sm text-black/60 dark:text-white/60">YOY Revenue Growth</div>
              </div>
            </div>
          </div>

          {/* Right Column - Interactive Display */}
          <div className="relative">
            {/* <div className="bg-white/50 dark:bg-white/5 rounded-2xl p-8 backdrop-blur-xl border border-black/5 dark:border-white/10 shadow-2xl"> */}
            <RubiksCube width={window.innerWidth > 1024 ? 750 : window.innerWidth - 50} height={window.innerWidth > 1024 ? 750 : window.innerWidth - 50} />
              
              {/* Floating Elements */}
              {/* <div className="absolute -top-4 -right-4 bg-primary text-white px-4 py-2 rounded-lg shadow-lg transform rotate-3">
                Verified Partner
              </div>
              <div className="absolute -bottom-4 -left-4 bg-black dark:bg-white text-white dark:text-black px-4 py-2 rounded-lg shadow-lg transform -rotate-3">
                Top Rated Agency
              </div> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroAlt1;
